import Trade from '../MobileView/pages/Trade';
import History from '../MobileView/pages/History';
import Setting from '../MobileView/pages/Setting';
import { CiSettings, CiCircleList } from "react-icons/ci";
import { VscHistory } from "react-icons/vsc";
import { BsJournals } from "react-icons/bs";
import { IoMailOutline } from "react-icons/io5";
import { IoIosNotificationsOutline } from "react-icons/io";
import { PiTreeViewLight } from "react-icons/pi";
import { IoNewspaperOutline } from "react-icons/io5";
import { MdOutlineCandlestickChart } from "react-icons/md";
import { AiOutlineStock } from 'react-icons/ai'
import Chart from '../MobileView/pages/Chart.jsx';
import Alert from '../MobileView/pages/Alert.jsx'
import Account from '../MobileView/pages/Account.jsx';
import News from '../MobileView/pages/NewsComponent.jsx'
import Report from '../MobileView/pages/Report.jsx'
import Mail from '../MobileView/pages/MailComponent.jsx';
import Quotes from '../MobileView/pages/Quotes.jsx';
import Login from '../pages/auth/Login.jsx'
import MainAuth from '../pages/auth/Login/MainAuth.jsx';

export const mobileRoutes = [
  { path: "/quote", title: "Quote", component: Quotes, icon: <AiOutlineStock style={{ fontSize: 21 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "*", type: "private", component: Quotes, title: "Quote", isMobile: true, isMenu: false },
  { path: "/trade", title: "Trade", component: Trade, icon: <CiCircleList style={{ fontSize: 21 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/chart", title: "Chart", component: Chart, icon: <MdOutlineCandlestickChart style={{ fontSize: 24 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/history", title: "History", component: History, icon: <VscHistory style={{ fontSize: 21 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/alerts", title: "Alerts", component: Alert, icon: <IoIosNotificationsOutline style={{ fontSize: 24 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/mailBox", title: "Mail", component: Mail, icon: <IoMailOutline style={{ fontSize: 22 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/report", title: "Report", component: Report, icon: <BsJournals style={{ fontSize: 21 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/news", title: "News", component: News, icon: <IoNewspaperOutline style={{ fontSize: 21 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/accounts", title: "Accounts", component: Account, icon: <PiTreeViewLight style={{ fontSize: 22 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/settings", title: "Settings", component: Setting, icon: <CiSettings style={{ fontSize: 24 }} />, type: "private", isMobile: true, isMenu: true },
  { path: "/", type: "auth", component: MainAuth, title: "Login", isMobile: true, isMenu: false },
];
